module.exports = __webpack_public_path__ + "static/media/Bel.ea609d95.mp3";